import moment from 'moment';

export function stripTags(str: string | null): string {
  if (str == null) {
    return '';
  } else {
    const root = new DOMParser().parseFromString(str, 'text/html');
    return root.body?.textContent || '';
  }
}

export function date(date: string | null): string {
  return date != null ? moment(date).format('YYYY年MM月DD日') : '';
}

export function datetime(datetime: string | null): string {
  return datetime != null
    ? moment(datetime).format('YYYY年MM月DD日 HH:SS')
    : '';
}

export function filename(path: string | null): string {
  if (path == null) {
    return '';
  }

  const arr = /.+\/(.+?)([#;].*)?$/.exec(path);
  if (arr == null) {
    return '';
  }

  return arr[1];
}

export function browserName(): string {
  const userAgent = window.navigator.userAgent.toLowerCase();

  if (userAgent.indexOf('msie') !== -1) {
    return 'ie';
  } else if (userAgent.indexOf('chrome') !== -1) {
    return 'chrome';
  } else if (userAgent.indexOf('firefox') !== -1) {
    return 'firefox';
  } else if (userAgent.indexOf('safari') !== -1) {
    return 'safari';
  } else if (userAgent.indexOf('opera') !== -1) {
    return 'opera';
  } else if (userAgent.indexOf('gecko') !== -1) {
    return 'gecko';
  } else {
    return '';
  }
}
